import { Injectable, Injector } from '@angular/core';
import { CostCenterDivision } from '../entities/costCenterDivision';
import { LazyLoadEvent } from 'primeng/primeng';
import { HttpParams } from '@angular/common/http';
import { QueryOperator } from '../../shared/_utils/services/query-operator.enum';
import { BaseCrudService } from '../../shared/_utils/services/base-crud-service';

@Injectable()
export class CostCenterDivisionService extends BaseCrudService<CostCenterDivision> {

    public uri = '/api/costCenterDivision/';

    constructor(injector: Injector) {
        super(injector);
       //console.log('Instance CostCenterDivisionService');
    }

    buildSentence(entity?: CostCenterDivision, event?: LazyLoadEvent): HttpParams {
        if (entity) {
            let query = entity.code ? 'code' + QueryOperator.Contain + entity.code + QueryOperator.Split : QueryOperator.Empty;
            query = query.concat(entity.name ? 'name' + QueryOperator.Contain + entity.name + QueryOperator.Split : QueryOperator.Empty);

            if (entity.fiscalYear && entity.fiscalYear.id) {
                query = query.concat(
                  `fiscalYear.id${QueryOperator.Equal}${entity.fiscalYear.id}${QueryOperator.Split}`
                );
              }

            this.httpParams = this.httpParams.set(QueryOperator.QueryParam, query);
        }

        if (event) {
            const page = ((event.first + event.rows) / event.rows - 1 ).toString();
            const size = event.rows.toString();
            this.httpParams = this.httpParams.set(QueryOperator.PageParam, page);
            this.httpParams =  this.httpParams.set(QueryOperator.SizeParam, size);
        }
        return this.httpParams;
    }

}



// WEBPACK FOOTER //
// ./src/app/core/services/cost-center-division.service.ts